import { styled } from "@mui/system";
import { TextField as Text } from "@mui/material";
import PropTypes from "prop-types";
import theme from "themeProvider";

const TextField = styled(Text)(({ customPadding, highlightError }) => ({
  "& .MuiOutlinedInput-root .MuiOutlinedInput-input": {
    fontWeight: "unset",
    padding: customPadding,
  },
  "& fieldset": {
    borderColor: !!highlightError && `${theme.palette.error.dark}`,
  },
}));

TextField.propTypes = {
  customPadding: PropTypes.string,
  highlightError: PropTypes.bool,
};

export default TextField;
